export function setupAccountInfo_Apply(account_status) {
    // 계좌 유무 체크후, flex or none 처리
    document.querySelector('.AccountSection').style.display = (account_status === 0) ? 'none' : 'flex';

}